import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Image, LI, UL } from '../../../AbstractElements';
import { Groups } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';

const GroupCard = () => {
  return (
    <Col sm='12' xxl='6' className='box-col-12'>
      <Card>
        <HeaderCard title={Groups} />
        <CardBody className='card-body avatar-showcase'>
          <div className='customers d-inline-block avatar-group'>
            <UL as='ul' className='simple-list'>
              <LI className='d-inline-block'>
                <Image body={true} className='img-70 rounded-circle' src={require('../../../assets/images/user/3.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-70 rounded-circle' src={require('../../../assets/images/user/5.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-70 rounded-circle' src={require('../../../assets/images/user/1.jpg')} alt='' />
              </LI>
            </UL>
          </div>
          <div className='customers d-inline-block avatar-group'>
            <UL as='ul' className='simple-list'>
              <LI className='d-inline-block'>
                <Image body={true} className='img-50 rounded-circle' src={require('../../../assets/images/user/3.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-50 rounded-circle' src={require('../../../assets/images/user/5.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-50 rounded-circle' src={require('../../../assets/images/user/1.jpg')} alt='' />
              </LI>
            </UL>
          </div>
          <div className='customers d-inline-block avatar-group'>
            <UL as='ul' className='simple-list'>
              <LI className='d-inline-block'>
                <Image body={true} className='img-40 rounded-circle' src={require('../../../assets/images/user/3.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-40 rounded-circle' src={require('../../../assets/images/user/5.jpg')} alt='' />
              </LI>
              <LI className='d-inline-block'>
                <Image body={true} className='img-40 rounded-circle' src={require('../../../assets/images/user/1.jpg')} alt='' />
              </LI>
            </UL>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GroupCard;
